<!-- <p>navigate-back works!</p> -->
 @if(isMobileView){
  <div class="back-button-container" (click)="navigateBack()">
    <img [src]="'../../../../../assets/img/icons/back-arrow-icon.svg'" alt="arrow-narrow-right" class="" />
  </div>
}